import React from 'react';
import type { SiteRagReport } from '../../../../types/siteRag';
import { SectionShell } from '../SectionShell';
import { useEffectiveReportTheme } from '../../../../lib/useEffectiveReportTheme';
import { EditorialSubsection } from '../../report/editorial';

export const CulturalHistoricalSection: React.FC<{ report: SiteRagReport; label: string }> = ({ report, label }) => {
  const theme = useEffectiveReportTheme();
  const data = report.culturalHistorical;
  const hasData = !!data && !!(data.tribalConsultation || data.archaeologicalSensitivity || data.shpoConsultation);
  return (
    <SectionShell label={label} hasData={hasData}>
      {data?.tribalConsultation && (
        <EditorialSubsection theme={theme} label="Tribal Consultation (NHPA Section 106)">{data.tribalConsultation}</EditorialSubsection>
      )}
      {data?.archaeologicalSensitivity && (
        <EditorialSubsection theme={theme} label="Archaeological Sensitivity">{data.archaeologicalSensitivity}</EditorialSubsection>
      )}
      {data?.shpoConsultation && (
        <EditorialSubsection theme={theme} label="SHPO Consultation">{data.shpoConsultation}</EditorialSubsection>
      )}
    </SectionShell>
  );
};
